import { type UseQueryResult, useQuery } from '@tanstack/react-query';

import { sensitiveContentService } from '@/services/sensitive-content-service';
import type { SensitiveContent } from '@/types/core/sensitive-content';
import type { UUID } from '@/utils/uuid';

import { sensitiveContentQueryKeys } from './query-keys';

/** One row's metadata (never its value); null when it is gone. */
export function useSensitiveContentRow(
  tenantId: UUID,
  connectorId: UUID,
  id: string
): UseQueryResult<SensitiveContent | null, Error> {
  return useQuery<SensitiveContent | null, Error>({
    queryKey: sensitiveContentQueryKeys.row(tenantId, connectorId, id),
    queryFn: () => sensitiveContentService.get(tenantId, connectorId, id),
  });
}
